import React, { lazy, Suspense } from "react";
import Navbar from "../Navbar/Navbar";
import HeroSection from "../HeroSection/HeroSection";
import DetailsNavbar from "../DetailsNavbar/DetailsNavbar";
import CustomerNavbar from "../CustomerNavbar/CustomerNavbar";
import ModuleNavbar from "../ModuleNavbar";
const PaymentFeature = lazy(() => import("../../PaymentFeature/PaymentFeature"));
const FrequentlyAskedQuestion = lazy(() => import("../FrequentlyAskedQuestions/FrequentlyAskedQuestion"));
const Testimonial = lazy(() => import("../Testimonial/Testimonial"));
const Footer = lazy(() => import("../Footer/Footer"));
const ManageDebt = lazy(() => import("../ManageDebt/ManageDebt"));
const Certificates = lazy(() => import("../Certificates/Certificates"))

const Home = () => {
  return (
    <>
      <DetailsNavbar/>
      <HeroSection />

      <Suspense fallback={<div></div>}>
        <Certificates />
        <PaymentFeature />
        {/* <FrequentlyAskedQuestion /> */}
        <ManageDebt/>
        {/* <Testimonial /> */}
        <Footer />
      </Suspense>
    </>
  );
};

export default Home;
